module.exports = __webpack_public_path__ + "8947df199b4e8bd4c2e2620dfdd05594.png";